module.exports = __webpack_public_path__ + "img/order2.c3218ce4.png";